import styled from "@emotion/styled";

export const HeadingHero = styled.div`
  h1 {
    font-size: 5.75rem; //92.5392px
    line-height: 111px;
    color: var(--chakra-colors-blue700);
  }
  h2 {
    font-size: 3.1875rem; //51.356px
    line-height: 62px;
    text-transform: capitalize;
    color: var(--chakra-colors-blue700);
    margin-bottom: 2.5rem;
  }

  p {
    color: var(--chakra-colors-misc800);
    font-size: 1.75rem;
    line-height: 5rem;
  }
`;
